<template>
  <div>
    <cadastro-base
      :salvar="salvar"
      :cancelar-cadastro="cancelar"
      :custom-footer-style="'position: fixed;bottom: 0px;right: 0px;background-color: white;width: 100%'"
    >
      <template slot="conteudo">
        <b-row
          v-if="abaAcessada == 0"
          no-gutters
        >
          <b-col class="text-right">
            <dropdown-tag
              ref="tagContratante"
              :tags="tagsContratante"
              grupo-tags="Contratante"
              legenda="Tag Contratante"
              @enviar-pai="addTagTemplate"
            />
            <dropdown-tag
              ref="tagSocio"
              :tags="tagsSocio"
              grupo-tags="Sócio"
              legenda="Tag Sócio"
              @enviar-pai="addTagTemplate"
            />
            <dropdown-tag
              ref="tagProposta"
              :tags="tagsProposta"
              grupo-tags="Proposta"
              legenda="Tag Proposta"
              @enviar-pai="addTagTemplate"
            />
            <dropdown-tag
              ref="tagAssinatura"
              :tags="tagsAssinatura"
              grupo-tags="Assinatura"
              legenda="Tag Assinatura"
              @enviar-pai="addTagTemplate"
            />
            <b-btn
              id="imprimir-documento"
              size="sm"
              variant="primary"
              class="btn-outline-success"
              style="margin-right:0.25rem"
              @click="imprimir"
            >
              <font-awesome-icon
                :icon="faPrint"
                style="font-size:15px !important;width:20px"
              />Imprimir</b-btn>
          </b-col>
        </b-row>
        <b-tabs
          card
          @input="alterandoAba"
        >
          <b-tab
            ref="geral"
            no-body
            title="Editor de texto"
          >
            <div
              v-if="abaAcessada == 0"
            >
              <b-row>
                <b-col>
                  <fieldset class="font-weight-bold text-muted small">
                    Aqui você parametriza o template do contrato com as ferramentas disponíveis no editor de texto
                  </fieldset>
                </b-col>
                <b-col cols="12">
                  <hr
                    class="mx-0 mt-0 mb-2"
                    style="border-top: 1px solid #a3a4a66b !important;"
                  >
                </b-col>
                <b-col cols="12">
                  <quill-editor
                    ref="quillText"
                    v-model="form.contrato"
                    style="padding-bottom: 5%;"
                    toolbar="#my-toolbar"
                  />
                </b-col>
              </b-row>
            </div>
          </b-tab>
          <b-tab
            no-body
            title="Perfil do template"
          >
            <aba-parametrizacao
              v-if="abaAcessada == 1"
              ref="parametrizacao"
              titulo="Perfil do template"
              descricao="Aqui você parametriza o perfil do template, através desses dados é feito o vínculo com a proposta de forma automática"
              :value="form"
            />
          </b-tab>
        </b-tabs>

        <b-modal
          ref="modalUsuarioDocusign"
          size="sm"
        >
          <legend class="col-form-label pt-0">
            Selecione o usuário</legend>
          <b-select
            v-model="selecionado"
            :options="usuariosFiltrado"
            text-field="nomeCompleto"
            value-field="id"
          />
          <template #modal-footer>
            <b-btn
              variant="primary"
              class="btn btn-sm"
              :disabled="!selecionado"
              @click="setUsuarioTag"
            >
              Confirmar
            </b-btn>
          </template>
        </b-modal>
      </template>
    </cadastro-base>
  </div>
</template>

<style src="@core/scss/vue/libs/quill.scss" lang="scss"></style>
<style lang="scss">
.card-header{
  padding-bottom: 0px !important;
}

.ql-editor {
  overflow: auto;
  min-height: 300px;
  max-height: 700px;

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar {
    width: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #bfbfbf;
  }
}
</style>

<script>
import { quillEditor } from 'vue-quill-editor'
import {
  required,
} from '@validations'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faPrint,
  faTags,
} from '@fortawesome/free-solid-svg-icons'
import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'
import AbaParametrizacao from '@/app-modulo/comercial/Parametrizacao/ParametrizacaoTemplate/components/cadatro-parametrizacao/CadastroParametrizacao.vue'
import api from '@/app-modulo/comercial/Parametrizacao/ParametrizacaoTemplate/services/api'
import apiUsuarioInterno from '@/app-modulo/comuns/usuario-interno/shared/services/api'

export default {
  name: 'CadastroTemplate',
  components: {
    quillEditor,
    CadastroBase,
    AbaParametrizacao,
    FontAwesomeIcon,
    DropdownTag: () => import('@/shared/components/dropdown-tag/DropdownTag.vue'),
  },
  data() {
    return {
      faPrint,
      faTags,
      required,
      form: {
        template: 'contrato',
        tipoTemplate: 'nenhum',
      },
      abaAcessada: 0,
      templateOptions: [
        { value: 'contrato', text: 'Contrato' },
      ],
      propostaOptions: [
        { value: 'constituicao', text: 'Proposta honorários empresas em constituição' },
        { value: 'transeferencia', text: 'Proposta honorários empresas em transferência' },
      ],
      tagsContratante: ['Nome', 'CPF/CNPJ', 'CEP', 'Estado', 'Cidade', 'Bairro', 'Rua', 'Número', 'Nome Sócio Representante', 'CPF Sócio Representante'],
      tagsSocio: ['Nome', 'CPF/CNPJ', 'CEP', 'Estado', 'Cidade', 'Bairro', 'Rua', 'Número', 'Profissão', 'Função', 'Estado civil', 'Nacionalidade', 'Data de nascimento', 'Início repetição', 'Final repetição'],
      tagsProposta: ['Valor contrato (R$)', 'Valor contrato (Extenso)', 'Data início vigência contrato', 'Data atual contrato'],
      tagsAssinatura: ['Início assinatura sócio', 'Assinatura sócio', 'Final assinatura sócio', 'Assinatura Responsável', 'Assinatura Testemunha'],
      quill: {},
      usuarios: [],
      usuariosFiltrado: [],
      tagAtual: '',
      selecionado: null,
    }
  },
  created() {
    this.state = this.$route.path.indexOf('editar') > 0 ? 'editar' : 'novo'
    if (this.state === 'editar') {
      this.carregar(this.$route.params.id)
    }
  },
  methods: {
    carregar(id) {
      api.getTemplateById(id)
        .then(payload => {
          this.form = payload.data
        })
        .catch(err => {
          throw err
        })
    },
    cancelar() {
      this.$router.go(-1)
    },
    salvar() {
      return new Promise((resolve, reject) => {
        this.form.contrato = this.form.contrato.replace(/[\u200B-\u200D\uFEFF]/g, '')
        if (this.state === 'novo') {
          api.salvarTemplate(this.form)
            .then(() => {
              this.$router.go(-1)
              resolve('Template cadastrado com sucesso')
            })
            .catch(err => {
              reject(err)
            })
        } else {
          api.updateTemplate(this.form.id, this.form)
            .then(() => {
              this.$router.go(-1)
              resolve('Template alterado com sucesso')
            })
            .catch(err => {
              reject(err)
            })
        }
      })
    },
    addTagTemplate(value) {
      if (value.includes('{Assinatura Assinatura Responsável}') || value.includes('{Assinatura Assinatura Testemunha}')) {
        this.tagAtual = value
        if (!this.usuarios || this.usuarios.length === 0) {
          apiUsuarioInterno.getUsuariosMarcacaoDocuSign()
            .then(payload => {
              this.usuarios = payload.data
              this.usuariosFiltrado = value.includes('Responsável') ? this.usuarios.filter(fil => fil.docuSignResponsavel) : this.usuarios.filter(fil => fil.docuSignTestemunha)
              this.$refs.modalUsuarioDocusign.show()
            })
        } else {
          this.usuariosFiltrado = value.includes('Responsável') ? this.usuarios.filter(fil => fil.docuSignResponsavel) : this.usuarios.filter(fil => fil.docuSignTestemunha)
          this.$refs.modalUsuarioDocusign.show()
        }
      } else {
        this.quill = this.$refs.quillText.quill
        this.quill.insertText(this.quill.getSelection(true), value, 'bold', true)
        this.quill.setSelection(this.quill.getSelection(true).index)
        this.quill.insertText(this.quill.getSelection(true), ' ', 'bold', false)
      }
    },
    setUsuarioTag() {
      const usuario = this.usuarios.find(find => find.id === this.selecionado)
      this.quill = this.$refs.quillText.quill
      const tag = this.tagAtual.replace('}', ` ${usuario.id} - ${usuario.nomeCompleto}}`)
      this.quill.insertText(this.quill.getSelection(true), tag, 'bold', true)
      this.quill.setSelection(this.quill.getSelection(true).index)
      this.quill.insertText(this.quill.getSelection(true), ' ', 'bold', false)
      this.selecionado = null
      this.$refs.modalUsuarioDocusign.hide()
    },
    imprimir() {
      const winPrint = window.open('', '', 'left=0,top=0,bottom=100,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      if (this.form.contrato) {
        winPrint.document.write(`<!DOCTYPE html>
        <html xmlns="http://www.w3.org/1999/xhtml">
          <head>
              <title>Print Test</title>
              <style type="text/css" media="print">
              @page 
              {
                  size:  auto;
                  margin: 0mm;
              }

              html
              {
                  background-color: #FFFFFF; 
                  margin: 0px;
              }

              body
              {
                  border: solid 1px white ;
                  margin: 10mm 15mm 10mm 15mm;
              }
              </style>
          </head>
          <body>
            <div>
              ${this.form.contrato}
            </div>
          </body>
        </html>`)
      }

      winPrint.document.close()
      winPrint.focus()
      winPrint.print()
      winPrint.close()
    },
    alterandoAba(newIndex) {
      this.abaAcessada = newIndex
    },
  },
}
</script>
